import { render, staticRenderFns } from "./Irremote.vue?vue&type=template&id=749ab490&scoped=true"
import script from "./Irremote.vue?vue&type=script&lang=js"
export * from "./Irremote.vue?vue&type=script&lang=js"
import style0 from "./Irremote.vue?vue&type=style&index=0&id=749ab490&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749ab490",
  null
  
)

export default component.exports